import { memo, ReactElement, useCallback, useState } from 'react';
import { Panel } from 'primereact/panel';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';

import { HttpService } from "../../../services/HttpService";
import FilePreviewOverlay from '../../../uiComponents/FilePreviewOverlay/FilePreviewOverlay';
type PropTypes = {
    orders: any[]
};

function ShippedDocumentsList(props: PropTypes): ReactElement {
    const {
        orders
    } = props;

    const [pdfUrl, setPdfUrl] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);

    const onPreviewhandler = useCallback((orderNumber: string, documentStatus: string): void => {
        setPreviewLoading(true);
        HttpService.get(
            `/api/return-shipment/presigned-url/${orderNumber}/file/${documentStatus}`
        ).then(res => {
            setPdfUrl(res.data.url);
        }).catch().
        finally(() => {
            setPreviewLoading(false);
        });
    }, [orders]);
    return (
        <Panel
            toggleable
            collapsed={!expanded}
            pt={{
                content: {
                    className: "border-0 shadow-none px-0 py-1"
                }
            }}
            onToggle={(e) => setExpanded(!e.value)}
            headerTemplate={(options) => {
                const { onTogglerClick } = options;

                return (
                    <div className="flex align-items-center justify-content-between py-2 w-full">
                        <div className="font-bold text-lg text-color">
                            <span className="mr-1">Included Orders: </span>
                            <span>{orders.length}</span>
                        </div>
                        <button
                            aria-label="Toggle"
                            onClick={onTogglerClick}
                            className="p-1 cursor-pointer p-component font-semibold">
                            <i className={expanded ? 'pi pi-chevron-down rotate-180' : 'pi pi-chevron-up rotate-180'} />
                        </button>
                    </div>
                )
            }}>
            {
                orders.map((order) => {
                    return (
                        <div key={order.orderNumber} className="pt-2 pb-3 border-top-1 surface-border flex flex-column gap-3">
                            <div className="flex-grow-1 text-color">
                                <div className="font-semibold text-lg">
                                    <span className="mr-1">Order</span>
                                    <span>#{order.orderNumber}</span>
                                </div>
                            </div>
                            {
                                order.documents.length ? (
                                    <div className="flex-grow-1">
                                        <div className="font-semibold text-lg text-color">
                                            Physical copies:
                                        </div>
                                        <ul className="list-none mt-2 pl-1">
                                            {
                                                order.documents.map((d: any) => {
                                                    return (
                                                        <li key={`${d.orderNumber}-${d.status}`} className="font-normal text-base text-color flex justify-content-between align-items-center">
                                                           <div>
                                                            <i className={classNames("mr-2 pi", {
                                                                "pi-file-word": d.status === "ACKNOWLEDGED_COPY",
                                                                "pi-envelope": d.status === "MAILED_COPY",
                                                                "pi-file": d.status === "RETURN_RECEIPT",
                                                            })} />
                                                            <span>{d.fileName}</span>
                                                           </div>
                                                            <Button
                                                                text
                                                                size="small"
                                                                label="Preview"
                                                                icon="pi pi-eye"
                                                                onClick={() => onPreviewhandler(order.orderNumber, d.status)}                                                            
                                                            />
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                ) : null
                            }
                        </div>
                    )
                })
            }
            <FilePreviewOverlay
                preview={pdfUrl}
                isLoading={previewLoading}
                closePreview={() => setPdfUrl('')}
                hideDownloadButton
            />
        </Panel>
    )
}

export default memo(ShippedDocumentsList);